import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-450be85f")

_pushScopeId("data-v-450be85f")
const _hoisted_1 = { class: "right-menu-item hover-effect navbar-notice-wrap" }
const _hoisted_2 = /*#__PURE__*/_createVNode("svg", {
  class: "navbar-notice-bell",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" })
], -1)
const _hoisted_3 = { class: "navbar-notice-panel" }
const _hoisted_4 = { class: "navbar-notice-title" }
const _hoisted_5 = {
  key: 0,
  class: "navbar-notice-body muted"
}
const _hoisted_6 = {
  key: 1,
  class: "navbar-notice-body error"
}
const _hoisted_7 = {
  key: 2,
  class: "navbar-notice-body muted"
}
const _hoisted_8 = {
  key: 3,
  class: "navbar-notice-body"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_badge = _resolveComponent("el-badge")
  const _component_el_popover = _resolveComponent("el-popover")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_popover, {
      placement: "bottom-end",
      width: 360,
      trigger: "click",
      onShow: _ctx.onPopoverShow
    }, {
      reference: _withId(() => [
        _createVNode("span", {
          class: "navbar-notice-trigger",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.markSeen && _ctx.markSeen(...args)))
        }, [
          _createVNode(_component_el_badge, {
            value: _ctx.displayCount,
            hidden: _ctx.displayCount === 0,
            class: "navbar-notice-badge"
          }, {
            default: _withId(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["value", "hidden"])
        ])
      ]),
      default: _withId(() => [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, _toDisplayString(_ctx.t("navbar.announcement")), 1),
          (_ctx.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.t("navbar.noticeLoading")), 1))
            : (_ctx.error)
              ? (_openBlock(), _createBlock("div", _hoisted_6, _toDisplayString(_ctx.t("navbar.noticeLoadFailed")), 1))
              : (!_ctx.noticeText)
                ? (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString(_ctx.t("navbar.noNotice")), 1))
                : (_openBlock(), _createBlock("div", _hoisted_8, _toDisplayString(_ctx.noticeText), 1))
        ])
      ]),
      _: 1
    }, 8, ["onShow"])
  ]))
})